"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TsRecordType = exports.SummaryTimestampLabelType = exports.QoS = void 0;
var QoS;
(function (QoS) {
    QoS[QoS["Realtime"] = 0] = "Realtime";
    QoS[QoS["Delayed"] = 1] = "Delayed";
    QoS[QoS["Unknown"] = 2] = "Unknown";
})(QoS || (exports.QoS = QoS = {}));
var SummaryTimestampLabelType;
(function (SummaryTimestampLabelType) {
    SummaryTimestampLabelType[SummaryTimestampLabelType["StartPeriod"] = 0] = "StartPeriod";
    SummaryTimestampLabelType[SummaryTimestampLabelType["EndPeriod"] = 1] = "EndPeriod";
})(SummaryTimestampLabelType || (exports.SummaryTimestampLabelType = SummaryTimestampLabelType = {}));
var TsRecordType;
(function (TsRecordType) {
    TsRecordType[TsRecordType["Tas"] = 1] = "Tas";
    TsRecordType[TsRecordType["Taq"] = 2] = "Taq";
    TsRecordType[TsRecordType["Correction"] = 4] = "Correction";
    TsRecordType[TsRecordType["Summary"] = 8] = "Summary";
})(TsRecordType || (exports.TsRecordType = TsRecordType = {}));
